/**
 * API endpoints for Reports domain to entralized endpoint configuration for all reports
 */
export const REPORT_ENDPOINTS = {
  FILTERS: '/v1/reports/filters',
  CHARTS: '/v1/reports/chart',
  SALES: {
    SUMMARY: '/v1/reports/query/1',
    DETAILS: '/v1/reports/query/2',
    EXPORT: '/v1/reports/export',
  },
  PAYMENTS: {
    SUMMARY: '/v1/reports/query/11',
    DETAILS: '/v1/reports/query/15',
    EXPORT: '/v1/reports/export',
  },
  PRODUCTS: {
    SUMMARY: '/v1/reports/query/16',
    DETAILS: '/v1/reports/query/17',
    EXPORT: '/v1/reports/export',
  },
  CANCELLATION: {
    SUMMARY_ORDERS: '/v1/reports/query/406',
    ORDER_DETAILS: '/v1/reports/query/407',
    SUMMARY_ITEMS: '/v1/reports/query/409',
    ITEM_DETAILS: '/v1/reports/query/408',
    EXPORT: '/v1/reports/export',
  },
};
